import * as React from "react";

import { 
    Confirm, 
    Main
} from "./Chapters";

export default (key, method) => {
    switch (key) {
        case "MAIN":
            return <Main method={method} />;
        default:
            return <Confirm />;
    }
};